export default "__VITE_ASSET__792574b3__"